import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  output,
  inject,
  input,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { AsyncPipe, SlicePipe } from '@angular/common';
import { InplaceModule } from 'primeng/inplace';
import { InputTextModule } from 'primeng/inputtext';
import { TaskCategoryService } from '@fitness-force/api';
import { ErrorMsgComponent } from '@fitness-force/errors';
import { ToastMessageService } from '@fitness-force/api';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
// import { FactoryHttpLoader } from '../../helpsupport/helpsupport.component';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'inplace-category-edit',
  templateUrl: './inplace-category-edit.component.html',
  styleUrls: ['./inplace-category-edit.component.scss'],
  providers: [ToastMessageService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    InplaceModule,
    ReactiveFormsModule,
    FormsModule,
    TooltipModule,
    InputTextModule,
    ErrorMsgComponent,
    TranslateModule,
    AsyncPipe,
    SlicePipe,
  ],
})
export class InplaceCategoryEditComponent implements OnInit {
  private formBuilder = inject(UntypedFormBuilder);
  private taskCategoryService = inject(TaskCategoryService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  readonly additionData = input(new BehaviorSubject(null));
  readonly columnData = input(new BehaviorSubject(null));
  cData: any;
  aData: any;

  edit = false;
  inplaceForm!: UntypedFormGroup;
  readonly onAction = output<{ action: string; columnData: any }>();
  categoryForm: any;
  value!: string;
  isFormSubmitting = new BehaviorSubject(false);

  ngOnInit(): void {
    combineLatest([this.additionData(), this.columnData()])
      .pipe(take(1))
      .subscribe({
        next: (data: any) => {
          this.aData = data[0];
          this.cData = data[1];
          this.value = this.aData.primary
            ? this.cData.name_primary_language
            : this.cData.name_secondary_language;
          this.buildForm();
        },
      });
  }

  buildForm() {
    this.inplaceForm = this.formBuilder.group({
      value: [
        this.aData.primary
          ? this.cData.name_primary_language
          : this.cData.name_secondary_language,
        [Validators.required],
      ],
    });
  }

  updateValue() {
    if (this.inplaceForm.valid) {
      let rawValue = this.inplaceForm.getRawValue();
      this.isFormSubmitting.next(true);
      if (
        this.aData.primary &&
        rawValue.value != this.cData.name_primary_language
      ) {
        let inputData = {
          name_primary_language: rawValue.value,
          name_secondary_language: this.cData.name_secondary_language
            ? this.cData.name_secondary_language
            : '',
        };
        this.taskCategoryService
          .updateTaskCategory(this.cData.tenant_id, this.cData.id, inputData)
          .subscribe({
            next: (res: any) => {
              this.isFormSubmitting.next(false);
              this.onAction.emit({
                action: 'categoryUpdated',
                columnData: this.cData,
              });
              this.edit = false;
            },
            error: (error: any) => {
              this.isFormSubmitting.next(false);
              this.handleError(error);
              this.onAction.emit({
                action: 'categoryUpdatedError',
                columnData: this.cData,
              });
            },
          });
      } else if (
        !this.aData.primary &&
        rawValue.value != this.cData.name_secondary_language
      ) {
        let inputData = {
          name_secondary_language: rawValue.value,
          name_primary_language: this.cData.name_primary_language,
        };
        this.taskCategoryService
          .updateTaskCategory(this.cData.tenant_id, this.cData.id, inputData)
          .subscribe({
            next: (res: any) => {
              this.isFormSubmitting.next(false);
              this.onAction.emit({
                action: 'categoryUpdated',
                columnData: this.cData,
              });
              this.edit = false;
            },
            error: (error: any) => {
              this.isFormSubmitting.next(false);
              this.handleError(error);
              this.onAction.emit({
                action: 'categoryUpdatedError',
                columnData: this.cData,
              });
            },
          });
      }
    } else {
      this.edit = false;
    }
  }

  handleError(error: any) {
    if (
      error.originalError &&
      error.originalError.error &&
      error.originalError.error[0]
    ) {
      let currentError = error.originalError.error[0];
      if (currentError.errorCode == 'duplicatevalue') {
        this.inplaceForm.controls['value'].setErrors({
          duplicate: true,
        });
        this.changeDetectorRef.detectChanges();
      }
    }
  }

  close() {
    this.edit = false;
    this.buildForm();
  }

  onKeyEnter(event: any) {
    this.updateValue();
  }
  onKeyEscape(event: any) {
    this.close();
  }
}
